module.exports = __webpack_public_path__ + "static/img/连接器.57003775.png";